import { union, uniqBy } from 'lodash';
import * as React from 'react';
import { IAltText } from '../../classes/alt-text';
import { Level } from '../../classes/level';
import LevelSelectSvg from "../../common/level-select/level-select";
import { getCurrencyFormat } from '../../helpers/currency-format';
import { isPhone } from '../../helpers/is-mobile';
import { resetVenueLevels, selectVenueLevel } from '../actions/filter-actions';
import { convertStringToNumberList } from '../../helpers/array-helpers';

declare var Modernizr;

interface IVenueLevelFilterProps {
    levels: Array<Level>;
    currencyFormat: string;
    levelsHeading: string;
    clearButton: string;
    levelsSectionMessage: string;
    showPricingOnLevelFilter: boolean;
    showLevelAvailabilityOnLevelFilter: boolean;
    levelAvailableCountMessage: string;
    seatmapBackgroundImage: string;
    altText: IAltText;

    svgDefaultFillColor: string;
    svgHoverFillColor: string;
    svgStrokeColor: string;
    svgStrokeWidth: number;
    svgSelectedFillColor: string;
    seatmapSvgViewBox: string;
    venueSvgHighlightShading: string;
    onSelectLevel: (evt) => void;
    onResetLevels: (evt) => void;
    venueBackgroundPaths: Array<string>;
    dispatch: any;
    selectedPriceTypeIdsString: string;
    selectedLevelString: string;

    showComponent: boolean;

    isCheckbox: boolean;
}

class VenueLevelListFilter extends React.PureComponent<IVenueLevelFilterProps, { hoveredLevel: number }>{
    constructor(props: IVenueLevelFilterProps) {
        super(props);
        this.state = {
            hoveredLevel: null
        };
    }

    renderPrice(level: Level, selectedPriceTypeIds: Array<number>) {
        let pricesForSelectedPriceType = uniqBy(level.priceTypePrices, pr => { return pr.price });
        if (selectedPriceTypeIds.length > 0) {
            pricesForSelectedPriceType = uniqBy((level.priceTypePrices.filter(price => selectedPriceTypeIds.indexOf(price.priceTypeId) >= 0)), pr => { return pr.price });
        }
        
        if (pricesForSelectedPriceType.length < 1)
            return '';
        else if (pricesForSelectedPriceType.length == 1)
            return getCurrencyFormat(this.props.currencyFormat, pricesForSelectedPriceType[0].price);
        else {
            const prices = pricesForSelectedPriceType.map(pt => pt.price);
            var sorted = prices.sort((a, b) => { return a - b; });
            var min = getCurrencyFormat(this.props.currencyFormat, sorted[0]);
            var max = getCurrencyFormat(this.props.currencyFormat, sorted[prices.length - 1]);
            return min + ' - ' + max;

        }
    }

    render() {
        if (this.props.showComponent) {
            var highlightedLevels = uniqBy((this.props.selectedLevelString.split(',').map(str => +str).concat(this.state.hoveredLevel == null ? [] : [this.state.hoveredLevel])),
                lvl => {
                    return lvl;
                }
            );

            return (
                <div className="filters-section">
                    <div className="filters-section-heading contains-btn">
                        <h2 className="heading-general">{this.props.levelsHeading}</h2>
                        {this.props.clearButton.length > 0 ?
                            <button className="filters-section-heading-btn" value={this.props.clearButton} onClick={this.props.onResetLevels.bind(this)}>
                                {this.props.clearButton}<span className="visually-hidden"> {this.props.levelsHeading}</span>
                            </button>
                            : null
                        }
                    </div>
                    {(this.props.levelsSectionMessage.length > 0) &&
                        <p className="caption-paragraph">{this.props.levelsSectionMessage}</p>
                    }
                    <div className="venue-level-container">

                        <ul className="venue-level-list">
                            {
                                this.props.levels.sort((a, b) => { return b.levelNumber - a.levelNumber }).map(level => {
                                    return <li className={"venue-level-list-item" + (!level.disabled && this.state.hoveredLevel === level.levelNumber && !Modernizr.touchevents ? " active" : "") + (level.disabled ? " disabled" : "")} key={level.levelNumber}
                                        onMouseOver={() => { !level.disabled ? this._onMouseOverLevel(level.levelNumber) : null }}
                                        onMouseLeave={() => { this._onMouseLeaveLevel() }} data-level-id={level.levelNumber}>
                                        <input id={level.name} type={this.props.isCheckbox ? "checkbox" : "radio"}
                                            className={this.props.isCheckbox ? "checkbox-custom" : "radio-custom"}
                                            disabled={level.disabled}
                                            checked={level.selected || this.props.selectedLevelString.split(',').indexOf(level.levelNumber.toString()) >= 0} value={level.name}
                                            onChange={() => this.props.onSelectLevel(level)}
                                            onClick={() => { if (!this.props.isCheckbox) this.props.onSelectLevel(level) }}
                                            name="levels-radios" />
                                        <label htmlFor={level.name}>{level.name}</label>

                                        <div className="venue-level-list-item-info">
                                            {this.props.showPricingOnLevelFilter ?
                                                <p className="venue-level-list-item-info-prices">
                                                    {this.renderPrice(level, convertStringToNumberList(this.props.selectedPriceTypeIdsString))}
                                                </p>
                                                : null}
                                            {this.props.showLevelAvailabilityOnLevelFilter && level.availableCount >= 0 ?
                                                <p className="venue-level-list-item-info-seats">
                                                    {this.props.levelAvailableCountMessage.replace("{0}", level.availableCount.toString())}
                                                </p>
                                                : null
                                            }
                                        </div>

                                    </li>
                                })
                            }
                        </ul>
                        <div className="venue-level-svg-container">
                            <div className="venue-level-svg-container-inner" style={{
                                paddingBottom: this.returnSvgRatio(this.props) as React.ReactText
                            }}>
                                <LevelSelectSvg
                                    altText={this.props.altText}
                                    hoveredLevel={this.state.hoveredLevel}
                                    levels={this.props.levels}
                                    onMouseLeaveLevel={this._onMouseLeaveLevel}
                                    onMouseOverLevel={this._onMouseOverLevel}
                                    onSelectVenueLevel={this.props.onSelectLevel}
                                    venueBackgroundImage={this.props.seatmapBackgroundImage}
                                    venueBackgroundPaths={this.props.venueBackgroundPaths}
                                    selectedLevelsString={this.props.selectedLevelString}
                                    svgDefaultFillColor={this.props.svgDefaultFillColor}
                                    svgHoverFillColor={this.props.svgHoverFillColor}
                                    svgSelectedFillColor={this.props.svgSelectedFillColor}
                                    svgStrokeColor={this.props.svgStrokeColor}
                                    svgStrokeWidth={this.props.svgStrokeWidth}
                                    venueSvgHighlightShading={this.props.venueSvgHighlightShading}
                                    venueSvgViewBox={this.props.seatmapSvgViewBox}
                                    svgClass="venue-level-svg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    componentWillReceiveProps(nextProps: IVenueLevelFilterProps) {
        this.setState({
            ...this.state,
            selectedLevelString: nextProps.levels.filter(level => {
                return level.selected;
            }).map(level => {
                return level.levelNumber;
            }).toString()
        } as any)
    }

    _onMouseOverLevel = (level) => {
        const newState = {
            ...this.state,
            hoveredLevel: level
        };

        this.setState(newState as any);
    };

    _onMouseLeaveLevel = () => {
        const newState = {
            ...this.state,
            hoveredLevel: null
        };

        this.setState(newState as any);
    };

    //_onSelectVenueLevel = (level: Level) => {
    //    let stateSelectedLevels = this.state.selectedLevelString.split(',').map(str => +str);

    //    var updatedSelected = {
    //        selectedLevelString: union(stateSelectedLevels, [level.levelNumber]).toString()
    //    };

    //    if (stateSelectedLevels.indexOf(level.levelNumber) >= 0) {
    //        updatedSelected = {
    //            selectedLevelString: stateSelectedLevels.filter((selectedLevel) => { return selectedLevel !== level.levelNumber }).toString()
    //        };
    //    }

    //    const newState = { ...this.state, ...updatedSelected };
    //    this.setState(newState as any);

    //    this.props.dispatch(selectVenueLevel(level.levelNumber));
    //};

    //_onResetVenueLevel() {
    //    const newState = {
    //        ...this.state,
    //        selectedLevelString: ""
    //    };

    //    this.setState(newState as any);
    //    this.props.dispatch(resetVenueLevels());
    //}

    returnSvgRatio(props: IVenueLevelFilterProps) {
        let splitSvgViewBox = props.seatmapSvgViewBox.split(" ");
        let svgWidth = parseInt(splitSvgViewBox[2]);
        let svgHeight = parseInt(splitSvgViewBox[3]);
        return ((svgHeight / svgWidth) * 100) + "%";
    }
}

export default VenueLevelListFilter;